<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            <CRow style="width:100%">
              <CCol md="12" lg="12" xl="12"> Analítica </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <h2 class="text-center">Indicadores de productividad</h2>
            <div class="dash-panel">
              <section
                class="dash-panel-row"
                v-for="(row, i) in _charts_"
                :key="i"
              >
                <h4 class="dash-panel-subtitle">{{ row.categoria }}</h4>
                <article
                  class="dash-panel-col"
                  v-for="(item, ix) in row.charts"
                  :key="ix"
                >
                  <router-link
                    :to="{
                      name: 'AnalyticsChart',
                      params: { chart: item, ...makeReport(item) }
                    }"
                  >
                    <i :class="getIconByTipo(item)"></i>
                    <span>{{ item.titulo }}</span>
                  </router-link>
                </article>
              </section>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "AnalyticsDashboard",
  computed: {
    _charts_() {
      return this.charts.reduce((v, c) => {
        const found = v.find(f => f.categoria === c.categoria);
        if (found) {
          found.charts = [...found.charts, c].sort((a, b) =>
            a.titulo.localeCompare(b.titulo)
          );
        } else {
          v.push({
            categoria: c.categoria,
            charts: [c]
          });
        }
        return v;
      }, []);
    }
  },
  data() {
    return {
      charts: [],
      panel: [
        {
          subtitle: "Administración",
          apps: [
            {
              name: "Gastos",
              to: {
                name: "Gasto"
              },
              icon: "fa fa-files-o"
            }
          ]
        },
        {
          subtitle: "Nómina",
          apps: [
            {
              name: "Labores",
              to: {
                name: "Labor"
              },
              icon: "fa fa-tag"
            },
            {
              name: "Prestamos",
              to: {
                name: "Prestamo"
              },
              icon: "fa fa-handshake-o"
            },
            {
              name: "Bonos",
              to: {
                name: "Bono"
              },
              icon: "fa fa-money"
            },
            {
              name: "Caja de Ahorro",
              to: {
                name: "CajaAhorro"
              },
              icon: "fa fa-archive"
            }
          ]
        },
        {
          subtitle: "Producción",
          apps: [
            // {
            //   name: "Riego",
            //   to: {
            //     name: "Riego"
            //   },
            //   icon: "fa fa-tint"
            // },
            {
              name: "Producciones",
              to: {
                name: "Produccion"
              },
              icon: "fa fa-tasks"
            },
            {
              name: "Entregas",
              to: {
                name: "Entrega"
              },
              icon: "fa fa-sign-in"
            }
          ]
        }
      ]
    };
  },
  created() {
    this.fetchData();
    this.$store.dispatch("setPreFilter", {});
    this.$store.dispatch("setGoBack", null);
  },
  methods: {
    makeReport(item) {
      return {
        label: item.titulo,
        reporte: item.nombre,
        filtros: {}
      };
    },
    getIconByTipo({ tipo }) {
      if (tipo.includes("drill-down")) {
        return "fa fa-angle-double-down";
      }
      if (tipo.includes("collapse-list")) {
        return "fa fa-caret-square-o-down";
      }
      if (tipo.includes("table")) {
        return "fa fa-table";
      }
      if (tipo.includes("pay")) {
        return "fa fa-pie-chart";
      }
      if (tipo.includes("indicador")) {
        return "fa fa-th";
      }
      if (tipo.includes("line")) {
        return "fa fa-line-chart";
      }
      if (tipo.includes("tree")) {
        return "fa fa-outdent";
      }
      return "";
    },
    fetchData() {
      this.$store
        .dispatch("actMethod", {
          url: "reportes:consultar_app",
          //reportes: dashChart,
          atributos: {
            dashboard: true
          }
        })
        .then(res => {
          console.log(res);
          this.charts = res.data;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
<style lang="scss" scoped>
.dash-panel {
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 90%;
  margin: 0 auto;
  section.dash-panel-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: space-evenly;
    flex-wrap: wrap;
    h4.dash-panel-subtitle {
      width: 100%;
      margin: 0;
      text-transform: capitalize;
    }
    article.dash-panel-col {
      width: 120px;
      height: 120px;
      background-color: #172b4d;
      border-radius: 60px;
      padding: 10px;
      margin: 10px;
      gap: 10px;
      a {
        color: #fff;
        display: grid;
        font-size: 14px;
        width: 100%;
        height: 100%;
        text-align: center;
        grid-template-rows: 1fr 1fr;
        align-content: center;
        &:hover {
          text-decoration: none;
        }
        i {
          font-size: 32px;
          align-self: end;
        }
      }
    }
  }
}
</style>
